var plugin_default = {
  "alignLeft": "rKpRL",
  "textWrapNowrap": "MfWf7",
  "alignRight": "_1lPZz",
  "alignCenter": "ECeI-",
  "sizeFullWidth": "J1-Nc",
  "renderedInTable": "bh2Kt",
  "sizeOriginal": "Zzp1U",
  "sizeContent": "uKjlo",
  "sizeSmall": "miKIt",
  "sizeSmallCenter": "pYKN1",
  "flex": "sqVUp",
  "atomic": "TRlMY",
  "embed": "xa4rx",
  "horizontalScrollbar": "Hm9wx",
  "pluginContainerMobile": "G25nd"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
